import { isDate } from './type-utils';
export function wixDataEncoder(operand) {
    if (isDate(operand)) {
        return { $date: operand.toJSON() };
    }
    else {
        return operand;
    }
}
//# sourceMappingURL=wix-data-encoder.js.map